console.log('External script loaded');
function initLoadMoreExternal() {
  var loadMoreBtn = document.getElementById('loadMoreBtn');
  if (loadMoreBtn) {
    console.log('External: Load More button found');
    loadMoreBtn.addEventListener('click', function() {
      console.log('External: Load More button clicked');
      var hiddenCards = document.querySelectorAll('.review-card.hidden');
      hiddenCards.forEach(function(card) {
        card.classList.remove('hidden');
      });
      loadMoreBtn.style.display = 'none';
    });
  } else {
    console.log('External: Load More button not found, retrying...');
    setTimeout(initLoadMoreExternal, 500);
  }
}
window.addEventListener('load', initLoadMoreExternal);